import services from './index.jsx';
import httpcommon from './httpcommon.jsx';
class Plans {

    getPlans() {
        return services.get("fivecareplans?populate=deep")
    }
};
export default new Plans();